import { StacksMainnet, StacksMocknet, StacksNetwork, StacksTestnet } from '@stacks/network';
import BigNumber from 'bignumber.js';

// export const isMainnet = true;

const fmt = {
  decimalSeparator: '.',
  groupSeparator: ',',
  groupSize: 3,
  secondaryGroupSize: 0,
  fractionGroupSeparator: ' ',
  fractionGroupSize: 0,
};
BigNumber.config({ FORMAT: fmt });

const STREAM_PLATFORM_CONTRACT_NAME = 'asigna-stream-platform';

export type NETWORK = 'mainnet' | 'testnet';

export const NETWORKS: Record<NETWORK, StacksNetwork> = {
  mainnet: new StacksMainnet(),
  testnet: process.env.REACT_APP_DEVNET === 'true' ? new StacksMocknet() : new StacksTestnet(),
  // 'testnet': new StacksTestnet()
};

export const UTILS_DEPLOYER_ADDRESS: Record<NETWORK, string> = {
  mainnet: 'SP18D3B11TP5HJJHDEXYNXECN2C6SA7VK38D05ZH7',
  testnet: 'STRBZQSMBGJ2EESFP58SR57EVAGSJBYXVMXC04MY',
};

export const STX_DECIMALS = 6;

export const DISPLAY_DIGITS_AFTER_ZERO = 6;

export const CONNECT_MESSAGE = 'Welcome to Asigna!';

interface FeeConfig {
  streamFee: bigint;
  autoclaimFee: bigint;
  lockFee: bigint;
  lockFlatFee: bigint;
}

export const AUTOCLAIM_MIN_PERIOD = 86400000;

export const PLATFORM_FEE_CONFIG: Record<NETWORK, FeeConfig> = {
  mainnet: {
    streamFee: BigInt(25000000),
    autoclaimFee: BigInt(10000),
    lockFee: BigInt(100000000),
    lockFlatFee: BigInt(50000000),
  },
  testnet: {
    streamFee: BigInt(25000000),
    autoclaimFee: BigInt(10000),
    lockFee: BigInt(100000000),
    lockFlatFee: BigInt(50000000),
  },
};

export const FEE_DIVIDER = BigInt(10000000000);
export const LOCK_FLAT_FEE = BigInt(50000000);

export const getStreamPlatformAddress = (network: StacksNetwork) => {
  return `${
    UTILS_DEPLOYER_ADDRESS[network.isMainnet() ? 'mainnet' : 'testnet']
  }.${STREAM_PLATFORM_CONTRACT_NAME}`;
};

export const PERMISSION_SIGNING_MESSAGE = 'Change permissions for owners:';
